export default {
  status: state => state.status,
  loading: state => state.loading,
  error: state => state.error,
  message: state => state.error && state.error.data.message,
  reminderEvent: state => state.reminderEvent,
  reminderEvents: state => state.reminderEvents,
}
